import {FETCH_WEEK} from '../actions'
import fetchWeek from './fetchWeek'

export default {action: FETCH_WEEK, afterHandler: fetchWeek}
